import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import './Error.css';

export const Error = ({ image, title, body, buttonText, buttonOnClick }) => (
  <div className="error-container">
    <Image className="error-image" src={image} />
    <p className="error-title">{title}</p>
    <p className="error-body">{body}</p>
    <button className="error-button" onClick={buttonOnClick}>
      {buttonText}
    </button>
  </div>
);

Error.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
};

Error.defaultProps = {
  image: '/emoji/weary.svg',
};



// WEBPACK FOOTER //
// ./src/components/views/Error.js